export default __webpack_public_path__ + "static/DW-Apple-945f32ae51d2c7e0c54436d37d86c068.svg";